import { NullableSerializer41etqlj0tdq5 as NullableSerializer } from '../internal/NullableSerializer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  ReferenceArraySerializer3juj1vqolxkrs as ReferenceArraySerializer,
} from '../internal/CollectionSerializers.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
  ByteSerializer_getInstance20v1505to7w0y as ByteSerializer_getInstance,
  ShortSerializer_getInstance1sui2olw3dzs8 as ShortSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  LongSerializer_getInstancepwtz4tlewrfw as LongSerializer_getInstance,
  FloatSerializer_getInstance1c6yoefuaocts as FloatSerializer_getInstance,
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
  CharSerializer_getInstancehi0q1kl0h8cw as CharSerializer_getInstance,
  UnitSerializer_getInstance13j6tqdl8rnmw as UnitSerializer_getInstance,
} from '../internal/Primitives.mjs';
import {
  ULongSerializer_getInstance6th9fj1q70m2 as ULongSerializer_getInstance,
  UIntSerializer_getInstance3tg9r9shlxhbj as UIntSerializer_getInstance,
  UByteSerializer_getInstance29ovrhqybz59q as UByteSerializer_getInstance,
  UShortSerializer_getInstance3bith9k7xv4n8 as UShortSerializer_getInstance,
} from '../internal/ValueClasses.mjs';
import {
  MapEntrySerializer2ukwamih4zw76 as MapEntrySerializer,
  PairSerializerpzh6nuee9oov as PairSerializer,
  TripleSerializer25andm5j3t9nu as TripleSerializer,
} from '../internal/Tuples.mjs';
import {
  CharArraySerializer_getInstance2mu447sxrz0td as CharArraySerializer_getInstance,
  DoubleArraySerializer_getInstance14oy86gxun29t as DoubleArraySerializer_getInstance,
  FloatArraySerializer_getInstancexaku2izexxhx as FloatArraySerializer_getInstance,
  LongArraySerializer_getInstance3jvz8bkl0kqnj as LongArraySerializer_getInstance,
  ULongArraySerializer_getInstancehm7rd2yih7u8 as ULongArraySerializer_getInstance,
  IntArraySerializer_getInstanceqou69s68jhpv as IntArraySerializer_getInstance,
  UIntArraySerializer_getInstancec7tztknra5r3 as UIntArraySerializer_getInstance,
  ShortArraySerializer_getInstance1401rzbbbe6ma as ShortArraySerializer_getInstance,
  UShortArraySerializer_getInstance3lvdig2cpj19w as UShortArraySerializer_getInstance,
  ByteArraySerializer_getInstance2fuv9a137bvc4 as ByteArraySerializer_getInstance,
  UByteArraySerializer_getInstance1d8h5wo399t1t as UByteArraySerializer_getInstance,
  BooleanArraySerializer_getInstance1u7esswhuhgdo as BooleanArraySerializer_getInstance,
} from '../internal/PrimitiveArraysSerializers.mjs';
import {
  NothingSerializer_getInstance2vzs25ljhki6v as NothingSerializer_getInstance,
  DurationSerializer_getInstance24c8qta2pbnpd as DurationSerializer_getInstance,
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
} from '../internal/BuiltInSerializers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_nullable(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.b1n().q1p()) {
    tmp = isInterface(_this__u8e3s4, KSerializer()) ? _this__u8e3s4 : THROW_CCE();
  } else {
    tmp = new (NullableSerializer())(_this__u8e3s4);
  }
  return tmp;
}
function MapSerializer(keySerializer, valueSerializer) {
  return new (LinkedHashMapSerializer())(keySerializer, valueSerializer);
}
function serializer(_this__u8e3s4) {
  return StringSerializer_getInstance();
}
function serializer_0(_this__u8e3s4) {
  return BooleanSerializer_getInstance();
}
function serializer_1(_this__u8e3s4) {
  return ByteSerializer_getInstance();
}
function serializer_2(_this__u8e3s4) {
  return ShortSerializer_getInstance();
}
function serializer_3(_this__u8e3s4) {
  return IntSerializer_getInstance();
}
function serializer_4(_this__u8e3s4) {
  return LongSerializer_getInstance();
}
function serializer_5(_this__u8e3s4) {
  return FloatSerializer_getInstance();
}
function serializer_6(_this__u8e3s4) {
  return DoubleSerializer_getInstance();
}
function serializer_7(_this__u8e3s4) {
  return CharSerializer_getInstance();
}
function ListSerializer(elementSerializer) {
  return new (ArrayListSerializer())(elementSerializer);
}
function serializer_8(_this__u8e3s4) {
  return ULongSerializer_getInstance();
}
function serializer_9(_this__u8e3s4) {
  return UIntSerializer_getInstance();
}
function serializer_10(_this__u8e3s4) {
  return UByteSerializer_getInstance();
}
function serializer_11(_this__u8e3s4) {
  return UShortSerializer_getInstance();
}
function SetSerializer(elementSerializer) {
  return new (LinkedHashSetSerializer())(elementSerializer);
}
function MapEntrySerializer_0(keySerializer, valueSerializer) {
  return new (MapEntrySerializer())(keySerializer, valueSerializer);
}
function PairSerializer_0(keySerializer, valueSerializer) {
  return new (PairSerializer())(keySerializer, valueSerializer);
}
function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
  return new (TripleSerializer())(aSerializer, bSerializer, cSerializer);
}
function ArraySerializer(kClass, elementSerializer) {
  return new (ReferenceArraySerializer())(kClass, elementSerializer);
}
function CharArraySerializer() {
  return CharArraySerializer_getInstance();
}
function DoubleArraySerializer() {
  return DoubleArraySerializer_getInstance();
}
function FloatArraySerializer() {
  return FloatArraySerializer_getInstance();
}
function LongArraySerializer() {
  return LongArraySerializer_getInstance();
}
function ULongArraySerializer() {
  return ULongArraySerializer_getInstance();
}
function IntArraySerializer() {
  return IntArraySerializer_getInstance();
}
function UIntArraySerializer() {
  return UIntArraySerializer_getInstance();
}
function ShortArraySerializer() {
  return ShortArraySerializer_getInstance();
}
function UShortArraySerializer() {
  return UShortArraySerializer_getInstance();
}
function ByteArraySerializer() {
  return ByteArraySerializer_getInstance();
}
function UByteArraySerializer() {
  return UByteArraySerializer_getInstance();
}
function BooleanArraySerializer() {
  return BooleanArraySerializer_getInstance();
}
function serializer_12(_this__u8e3s4) {
  return UnitSerializer_getInstance();
}
function NothingSerializer() {
  return NothingSerializer_getInstance();
}
function serializer_13(_this__u8e3s4) {
  return DurationSerializer_getInstance();
}
function serializer_14(_this__u8e3s4) {
  return InstantSerializer_getInstance();
}
function serializer_15(_this__u8e3s4) {
  return UuidSerializer_getInstance();
}
//region block: exports
export {
  ArraySerializer as ArraySerializermpxy3fgi5xnb,
  BooleanArraySerializer as BooleanArraySerializer1s3kgnkejzqxt,
  ByteArraySerializer as ByteArraySerializersn06x87bo7h0,
  CharArraySerializer as CharArraySerializerklmg8gfnksga,
  DoubleArraySerializer as DoubleArraySerializertger6kqq08hw,
  FloatArraySerializer as FloatArraySerializerr6nw52je2tta,
  IntArraySerializer as IntArraySerializer1m3fo301mmjdr,
  ListSerializer as ListSerializer1hxuk9dx5n9du,
  LongArraySerializer as LongArraySerializer13aridd43vtw2,
  MapEntrySerializer_0 as MapEntrySerializer3oe1sx5ozvw2u,
  MapSerializer as MapSerializer11kmegt3g5c1g,
  NothingSerializer as NothingSerializer3oixyyf77l4xt,
  PairSerializer_0 as PairSerializer1d18kmsqyj4f,
  SetSerializer as SetSerializert3lb0yy9iftr,
  ShortArraySerializer as ShortArraySerializer316766pkdw188,
  TripleSerializer_0 as TripleSerializer39fneesmgp1wy,
  UByteArraySerializer as UByteArraySerializer1sccfecbzq55o,
  UIntArraySerializer as UIntArraySerializermosjtc8kcdu0,
  ULongArraySerializer as ULongArraySerializer2p6vevd8k2lpe,
  UShortArraySerializer as UShortArraySerializer2x9pkk602s3ka,
  get_nullable as get_nullable197rfua9r7fsz,
  serializer_14 as serializer1j5a5justjsv5,
  serializer as serializer1x79l67jvwntn,
  serializer_2 as serializer1tw0a8bv7lkga,
  serializer_11 as serializer1q7c5q67ysppr,
  serializer_15 as serializer1x80idigipeic,
  serializer_12 as serializer1cdzkc3mnhoc4,
  serializer_1 as serializer1r0h5yakm679b,
  serializer_9 as serializer3ikrxnm8b29d6,
  serializer_6 as serializer1wpgysz06u9ol,
  serializer_3 as serializer1hu9wv9at41ww,
  serializer_10 as serializer36584sjyg5661,
  serializer_8 as serializer2lw83vwvpnyms,
  serializer_0 as serializer3u3hsxnenk49x,
  serializer_7 as serializer345btyh1f2y1j,
  serializer_4 as serializerodflzzf6s3fp,
  serializer_13 as serializer37oyvz7rc4nep,
  serializer_5 as serializer3x9uckd1deom,
};
//endregion

//# sourceMappingURL=BuiltinSerializers.mjs.map
